// extracted by mini-css-extract-plugin
export var alignDiscLeft = "v_sC d_fp d_bG d_dv";
export var alignLeft = "v_qh d_fp d_bG d_dv";
export var alignDiscCenter = "v_sD d_fq d_bD d_dw";
export var alignCenter = "v_bP d_fq d_bD d_dw";
export var alignDiscRight = "v_sF d_fr d_bH d_dx";
export var alignRight = "v_qj d_fr d_bH d_dx";
export var footerContainer = "v_sG d_dW d_bW";
export var footerContainerFull = "v_sH d_dT d_bW";
export var footerHeader = "v_kf d_kf";
export var footerTextWrapper = "v_sJ d_w";
export var footerDisclaimerWrapper = "v_km d_km d_ck";
export var badgeWrapper = "v_sK d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "v_sL d_bz d_bJ d_bN d_bL";
export var wide = "v_sM d_cy";
export var right = "v_sN d_bK";
export var line = "v_fk d_fl d_cv";
export var badgeDisclaimer = "v_sP d_bC d_bP d_bJ";
export var badgeContainer = "v_sQ d_bz d_bH d_bP";
export var badge = "v_sR";
export var padding = "v_sS d_c7";
export var end = "v_sT d_bH";
export var linkWrapper = "v_sV d_dB";
export var link = "v_mC d_dB";
export var colWrapper = "v_sW d_cx";
export var consent = "v_f d_f d_bC d_bP";
export var disclaimer = "v_sX d_bz d_bJ";
export var media = "v_sY d_bx d_dy";
export var itemRight = "v_sZ";
export var itemLeft = "v_s0";
export var itemCenter = "v_s1";
export var exceptionWeight = "v_s2 D_vs";